export default "__VITE_ASSET__caf48d8c__"